module.exports = __webpack_public_path__ + "img/867365e.jpg";